<header class="header-container">
  <img src="assets/logo.svg" alt="Logo" class="logo-image">
  <img src="assets/title.svg" alt="Title" class="title-image">
</header>